export enum OfferStatusCancelationWarning {
  Pending = 0,
  CanceledByBuyer = 1,
  CanceledByVendor = 2,
  CanceledBySystem = 3,
  OfferExpired = 4,
  AcceptedByBuyer = 5,
  AcceptedByVendor = 6
}
